import React from 'react'
import classnames from 'classnames'
import { getCurrentPath } from 'src/helpers/browser'
import { SubHeader } from 'src/Components/shared/Header'
import { FormattedMessage } from 'react-intl'
import { If, Select } from 'src/Components'
import { SubNavLink } from 'src/Components/shared/Navigation'
import { IconPlus } from 'src/Components/shared/Icon'
import HomeLink from './HomeLink'
import { getHomeId, getStreet } from 'src/store/selectors/home'
import { startCase } from 'src/store/selectors/utils'

import styles from './HomeownerSubNav.module.scss'

const SubNav = ({
  className,
  loaded,
  homeId,
  homes,
  addHomePath,
  navAddHome
}) => (
  <SubHeader
    className={classnames(className, styles.root, loaded && styles.loaded)}
  >
    <SubHeader.Content className={styles.contentSwapper}>
      <div className={styles.defaultRow}>
        {homes.map(home => (
          <HomeLink home={home} key={getHomeId(home)} />
        ))}
        <AddHomeLink path={addHomePath} />
      </div>
      <div className={styles.breaker} />
      <div className={styles.alternateRow}>
        <Select
          className={styles.select}
          value={homeId}
          optionKey='key'
          optionValue='value'
          options={homes.map(home => ({
            key: getHomeId(home),
            value: startCase(getStreet(home))
          }))}
          onChange={navAddHome}
        />
        <AddHomeLink path={addHomePath} />
      </div>
    </SubHeader.Content>
  </SubHeader>
)

const AddHomeLink = ({ path }) => (
  <If condition={path}>
    <SubNavLink
      className={styles.addHome}
      to={path}
      active={getCurrentPath().includes(path)}
    >
      <IconPlus />
      <FormattedMessage
        id='Homeowner.SubNav.addHome'
        defaultMessage='Add Home'
      />
    </SubNavLink>
  </If>
)

export default SubNav
